import { baseURLImage, getNameProfile } from "Utils/utils";
import React, { memo, useCallback } from "react";
import Progressbar from "./Progressbar";
import { Link } from "react-router-dom";
import "./ProgressTable.css";
import { roleAccess } from "helpers/RolesPermission";
import { PERMISSION_KEYS, PERMISSION_KEYS_CHILDREN } from "store/constants";

const ProgressTable = memo(({
  title,
  item,
  columnName,
  onLoadMore,
  loadingMore = false,
  hasMore = false,
  isParticipantSection = false,
}) => {
  const handleScroll = useCallback(
    (e) => {
      if (!onLoadMore || loadingMore || !hasMore) return;
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollHeight - scrollTop - clientHeight < 80) {
        onLoadMore();
      }
    },
    [onLoadMore, loadingMore, hasMore]
  );
  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname));
  };

  const handleRedirection = (element) => {
    if (
      isParticipantSection &&
      roleAccess(
        [],
        PERMISSION_KEYS.PARTICIPANT,
        PERMISSION_KEYS_CHILDREN.PARTICIPANT.DETAIL
      )
    ) {
      return `/sp-profile/${element?.uuid}`;
    } else if (
      !isParticipantSection &&
      roleAccess(
        [],
        PERMISSION_KEYS.HRM,
        PERMISSION_KEYS_CHILDREN.HRM.WORKER.SHOW
      )
    ) {
      return `/worker-profile/${element?.uuid}`;

    }
    return "#";
  };

  return (
    <div>
      <div className="mb-3 sm:mb-4">
        <div className="flex items-center gap-2">
          <div className="w-1 h-5 sm:h-6 bg-gradient-to-b from-blue-500 to-cyan-500 rounded-full"></div>
          <h3 className="text-base sm:text-lg font-bold text-gray-900">{title}</h3>
        </div>
      </div>

      <div
        className="h-[350px] sm:h-[400px] lg:h-[450px] overflow-x-auto overflow-y-auto rounded-lg mt-3 sm:mt-4 pb-4 custom-scroll"
        onScroll={onLoadMore ? handleScroll : undefined}
      >
        <div className="space-y-2">
          {item && item?.length > 0 ? (
            item?.map((element) => {
              const compliance = element?.compliance_score || element?.on_boarding_progress || 0;
              return (
                <Link
                  to={handleRedirection(element)}
                  key={element?.id}
                  className="block"
                >
                  <div className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md hover:border-blue-300 transition-all duration-200 group">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center flex-1 min-w-0">
                        <div className="h-12 w-12 flex-shrink-0 relative">
                          <img
                            onError={(e) =>
                              handleImageError(
                                e,
                                element?.first_name,
                                element?.last_name
                              )
                            }
                            className="object-cover h-12 w-12 rounded-full ring-2 ring-gray-200 group-hover:ring-blue-400 transition-all"
                            src={
                              element?.photo || element?.profile_picture
                                ? baseURLImage(
                                    element?.photo || element?.profile_picture
                                  )
                                : getNameProfile(
                                    element?.first_name,
                                    element?.last_name || " "
                                  )
                            }
                            alt=""
                          />
                        </div>
                        <div className="ml-4 flex-1 min-w-0">
                          <div
                            className="font-semibold text-sm text-gray-900 capitalize truncate group-hover:text-blue-600 transition-colors"
                            title={`${element?.first_name} ${element?.last_name}`}
                          >
                            {element?.first_name} {element?.last_name}
                          </div>
                          <div className="mt-2">
                            <Progressbar
                              compliance={compliance}
                              title={title}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })
          ) : (
            <div className="bg-white border border-gray-200 rounded-lg p-8 text-center">
              <p className="text-gray-500">
                {title === "Participants Compliance" || title === "Consumers Compliance"
                  ? `No ${title.replace(" Compliance", "").toLowerCase()} with compliance data available.`
                  : title === "HRM Compliance"
                  ? "No staff with compliance data available."
                  : "No data available"}
              </p>
            </div>
          )}
          {onLoadMore && loadingMore && (
            <div className="py-3 text-center text-sm text-gray-500">
              Loading more...
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

ProgressTable.displayName = 'ProgressTable';

export default ProgressTable;
